import { DEFAULT_CURRENCY } from "@/data/constants";
import { toMajorUnits } from "@/utils/toMajorUnits";
import { EstimateIntervalData } from "@/components/shared/interval-switch/estimate-interval-change";
import { TSwitchTodayAmounts } from "../types.dashboard";

/** The estimate's due-today breakdown for the confirm dialog (minor → major units). */
export function toSwitchTodayAmounts(
  estimate: EstimateIntervalData,
): TSwitchTodayAmounts {
  const toMajor = (amount = 0) =>
    toMajorUnits(amount, estimate.currency ?? DEFAULT_CURRENCY);

  return {
    proratedCredit: toMajor(estimate.prorated_amount),
    discount: toMajor(estimate.discount_total_amount),
    aftershootCredit: toMajor(estimate.credit_amount),
    amountDueToday: toMajor(estimate.amount_due),
  };
}
